<template>
  <div>
  <el-dialog title="商品信息" :visible.sync="visibleDialog" width="920px" top="calc(50vh - 220px)" class="pop-dialog pop-goods-info" append-to-body>
    <div class="goods-con" v-loading="loading">
      <el-table :data="tableData.items" height="300px">
        <el-table-column label="商品">
          <template slot-scope="scope">
            <div class="goods-info">
              <div class="img">
                <el-image :src="scope.row.goodsSkuPic || scope.row.goodsPic" class="pic"  fit="cover">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
              <div class="con">
                <div class="name">五域商品名称:{{ scope.row.goodsName || scope.row.wuyuGoodsName }}</div>
                <div class="name">五域商品规格:{{ scope.row.goodsSkuName  || scope.row.wuyuGoodsSpec  }}</div>
                <div class="name">体积：{{ scope.row.volume}}<span class="space"></span>重量：{{ scope.row.weight}}</div>
                <div class="text space-top">店铺商品名称:{{ scope.row.shopGoodsName}}</div>
                <div class="text">店铺商品规格:{{ scope.row.shopGoodsSpec}}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="编号" width="190">
          <template slot-scope="scope">
            <div class="name">商品编号：{{ scope.row.wyGoodsCode || scope.row.wuyuGoodsCode|| '缺失' }}</div>
            <div class="name">商品规格编号：{{ scope.row.wuyuSku || '缺失' }}</div>
            <div class="text">外部编号：{{ scope.row.outGoodsCode || '缺失' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" v-if="type==='edit'">
          <template slot-scope="scope">
            <div class="primary hand" @click="onEdit(scope.row)">编辑</div>
          </template>
        </el-table-column>
        <el-table-column label="价格" width="80">
          <template slot-scope="scope">
            <div class="name">￥{{scope.row.goodsPrice}}</div>
          </template>
        </el-table-column>
        <el-table-column label="数量" width="80">
          <template slot-scope="scope">
            <div class="name">*{{ scope.row.quantity}}</div>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="type==='edit'" class="total-con">
        总计：
        <div class="space-row">￥{{ tableData.totalGoodsAmount }}</div>
        <div class="space-row">*{{ tableData.totalItemCount }}</div>
      </div>
      <div v-else class="total-con">
        总计：共{{ tableData.totalItemCount}}件 
        <div class="space">商品总价：￥{{ tableData.totalGoodsAmount }}</div>
        <div class="space">运费：￥{{ tableData.totalFreightAmount }}</div>
        <div class="space">应付：￥{{ tableData.receivableAmount }}</div>
        <div class="space">已付：￥{{ tableData.paidAmount }}</div>
      </div>
    </div>
  </el-dialog>
  <!-- 编辑商品编码 -->
   <el-dialog title="录入/编辑商品编码" :visible.sync="eidtDialog" width="410px" top="calc(50vh - 90px)" class="pop-dialog pop-goods-edit" append-to-body>
    <el-form :model="form" :rules="rules" ref="form" label-width="120px" class="edit-con" size="mini">
      <el-form-item label="商品规格编号" prop="wyGoodsCode">
        <el-input v-model="form.wyGoodsCode" placeholder="请输入商品规格编号"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="eidtDialog = false" size="mini">取 消</el-button>
      <el-button type="primary" @click="onConfirm" size="mini"  :loading="loading">确 定</el-button>
    </template>
   </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'popGoodsInfo',
  data() {
    return {
      visibleDialog: false, // 商品信息
      loading: false,
      tableData: {
         items:[]
      },
      loading: false,
      type: '',
      orderNo:'',
      eidtDialog: false,// 编辑编号
      form: {
        orderId:'',
        outGoodsCode: '',
        wyGoodsCode:'',
      },
      rules: {
        wyGoodsCode: [
          { required: true, message: '请输入商品规格编号', trigger: 'blur' },
        ]
      }
    }
  },
  methods: {
    show(data) {
      this.type = data.type || ''
      this.orderNo = data.orderNo
      this.orderId = data.orderId
      this.tableData = {
        items:[]
      }
      console.log('show:', data)
      if(this.orderNo){
        this.fetchData()
      }
      this.visibleDialog = true
    },
    fetchData() {
      this.loading = true
       let APIURL = 'omsOrderItem'
       let params = this.orderNo
      if (this.type == 'edit') {
        APIURL = 'omsOrderGoodsList'
        params = {orderId:this.orderId}
      }
      this.$api[APIURL](params).then(res => {
        if (res.code == 0) { 
          if (this.type == 'edit') {
            this.tableData.items = res.data.itemList
            this.tableData.totalGoodsAmount = res.data.totalAmount
            this.tableData.totalItemCount = res.data.totalQuantity
            
          }else { 
            this.tableData = res.data
          }
        }
      }).finally(() => { 
        this.loading = false
      })
    },
    onEdit(item){
      this.form.orderId = item.id
      this.form.outGoodsCode = item.outGoodsCode
      this.form.wyGoodsCode = item.wuyuGoodsCode || ''
      this.eidtDialog = true
    },
    // 编辑编号
    onConfirm(){
      this.$refs.form.validate((valid) => {
          if (valid) {
            this.loading = true
            this.$api.omsSetCode(this.form).then(res => {
              if (res.code == 0) {
                console.log(res)
                if (res.data.success) {
                   this.eidtDialog = false
                  this.$message.success('录入编码正确，成功关联商品')
                  this.fetchData()
                }else{
                  this.$message.error('录入的编码不存在，关联商品失败')
                }
              }
            }).finally(() => { 
              this.loading = false
            })
          } else {
            console.log('error submit!!');
            return false;
          }
      })
    }
  },
}
</script>
<style lang='scss'>
.pop-goods-info {
  .goods-con {
    padding: 10px 0 0 0;
    
    .goods-info{
      display: flex;
      .img{
        margin-right: 12px;
        width: 40px;
        height: 40px;
        flex-shrink: 0;
         .el-image{
          text-align: center;
          line-height: 1;
          font-size: 16px;
          color: #bcbcbc;
          margin: 0 auto;
          width: 38px;
          height: 38px;
          .image-slot{
            line-height: 38px;
          }
          .el-image__placeholder{
            display: none;
          }
        }
        .pic{
          width: 40px;
          height: 40px;
        }
      }
      .space{
        display: inline-block;
        width: 20px;
      }
      .space-top{
        padding-top: 4px;
      }
      
    }
    .hand{
      cursor: pointer;
    }
    .name{
      color: #333;
    }
    .text{
      color: #7F7F7F;
    }
    
    .el-table{
      // border: 1px solid #E3E3E3;
      // border-bottom: none;
       .el-table__body-wrapper{
        scrollbar-width: thin;
       }
    }
    .el-table th.el-table__cell {
      padding: 0;
      height: 28px;
      line-height: 28px;
      font-weight: normal;
      background-color: #F8F8F8;

      .cell {
        font-size: 12px;
        font-weight: normal;
        padding-left: 12px;
        color: #7F7F7F;
      }
    }

    .el-table td.el-table__cell {
      padding: 0;
      padding: 6px 0 8px;

      .cell {
        font-size: 12px;
        padding-left: 12px;
        line-height: 18px;
      }


    }
    .el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell{
      background: #E3F0FC;
    }
  }

  .total-con {
    height: 57px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .space{
      padding-left: 20px;
    }
    .space-row{
      display: inline-block;
      width: 80px;
      text-align: left;
      box-sizing: border-box;
      padding-left: 12px;
    }
    .total-price {
      display: inline-block;
      // width: 80px;
      text-align: left;
      box-sizing: border-box;
      padding-left: 12px;
    }
    .total-number{
      display: inline-block;
      // width: 80px;
      text-align: left;
      box-sizing: border-box;
      padding-left: 12px;
    }
  }

}
// 编辑商品
.pop-goods-edit{ 
    .edit-con{
    padding-top: 20px;
  }
}

</style>